<template xmlns="http://www.w3.org/1999/html">
  <section>
    <section class="page1">
      <article class="container">
        <wl-title class="h1" title='关于米联' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="img"><img v-lazy="'/static/img/about/1-page1.png'" alt="关于米联"></section>
          <p>
            米联物联是一家专注于实验室智慧化与实验室数字化转型的国家高新技术企业。我们为高校、科研院所、医院、检测中心及企业提供一站式、智能化的实验室综合管理解决方案，涵盖智慧实验室管理平台、实验室物联网（AIoT）及数据中台建设。
            公司始终围绕实验室生态系统进行构建，通过多年研发创新，已打造出两大核心产品线——实验室智慧管理平台与实验室综合管理平台，实现了对实验室环境、设备、人员、样品与流程的全方位、多层次、全周期的数字化管理。我们以助力实验室实现更安全、更规范、更智能的运营为目标，推动科研管理工作向智能化、便捷化深度演进
            截至目前，米联物联已成功服务于全国300多家领先的科研与检测单位，助力客户实现实验室的智能化改造、数字化转型与信息化升级，让科研人员享受到更高效、更可靠的研发管理环境，全面提升科研生产力与实验室合规水平。
            我们以“让科研更简单、更智能”为使命，持续深耕实验室信息化领域，旨在成为全球智慧实验室解决方案的领先服务商，携手行业伙伴共同推动科研与检验检测的数字化未来。
          </p>
        </section>
        <section class="flex">
          <section class="box" v-for="(item,idx) in page1Data" :key="item.key">
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
            <section class="_icon " :style="`background-position: -${72*idx}px 0px;`"></section>
          </section>
        </section>
      </article>
    </section>
    <section class="page2 bg" v-lazy:background-image="'/static/img/about/1-page2-bg.png'">
      <article class="container">
        <wl-title title='完善的服务机制' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="fl_box" v-for="(item,idx) in page2Data" :key="item.key">
            <section class="_icon " :style="`background-position: -${72*idx}px 0px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <contact-page></contact-page>
    <submit-page></submit-page>
  </section>
</template>

<script>
import SubmitPage from '../../../components/submitPage.vue'
import contactPage from './contactPage.vue'
export default {
  components: { contactPage, SubmitPage },
  name: 'aboutCompany',
  data() {
    return {
      page1Str1: "米联信息科技成立于2015年，是一家专注做实验室信息化解决方案的提供商，致力于为科研人员提供智能化一站式的科研管理解决方案。\n米联信息科技一直围绕实验室的生态系统构建，经过多年的研发创新，拥有三大实验室产品线，包括",
      page1Str3: " 已实现实验室多方位、多层次、全流程的智慧实验管理模式，致力于发展成为实验室行业综合实力最强的信息化服务提供商！\n米联信息科技目前已服务了300+高校、科研单位、医院、检测机构、企业等单位，实现实验室智能化、数字化、信息化管理， 让更多科研用户享受到更加便捷的科研管理环境，助力实验室更安全更规范、更智能的全面构建，让科研更简单更便捷！",
      page1Data: [
        { title: '愿景', desc: '成为实验室行业综合实力\n最强的信息化服务提供商', key: 'about1-1' },
        { title: '使命', desc: '让实验室更安全，更智能\n让科研更便捷', key: 'about1-2' },
        { title: '目标', desc: '为用户提供实验室\n全方位的解决方案', key: 'about1-3' },
      ],
      page2Data: [
        { title: '售前服务', desc: '专业的售前咨询\n精准的需求分析\n完整的解决方案', key: 'about1-4' },
        { title: '技术支持', desc: '7*24小时服务\n现场、电话、在线远程支持\n专人跟进，全程无忧\n定制开发，迭代升级', key: 'about1-5' },
        { title: '实施服务', desc: '系统使用培训\n项目一对一服务\n多年项目专家现场实施', key: 'about1-6' },
      ],
    }
  },
  methods: {
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/about/icon-sprite.png");
}
p {
  white-space: pre-line;
  font-size: 24px;
  color: #8e8e8e;
}
h3 {
  color: #262626;
}
.page1 {
  height: 1367px;
  padding-top: 136px;
  .h1 {
    padding-bottom: 65px;
  }
  .flexWrap {
    padding-bottom: 98px;
    a{
      text-decoration:underline;
    }
    .img {
      width: 627px;
    }
    p {
      font-size: 20px;
      text-align: left;
      width: 602px;
      color: #262626;
      line-height: 34px;
      margin-top: -15px;
      text-align: justify;
    }
  }
  .box {
    flex: 1;
    height: 456px;
    border-top: 1px solid #e1e1e1;
    padding-top: 90px;
    background: #fff;
    &:nth-child(2) {
      border: 1px solid #e1e1e1;
      border-bottom: none;
    }
    h3 {
      line-height: 36px;
      font-size: 36px;
      font-weight: bold;
    }
    p {
      padding-bottom: 76px;
      line-height: 40px;
      padding-top: 20px;
    }
  }
  ._icon {
    width: 72px;
    height: 72px;
    display: inline-block;
  }
}
.page2 {
  height: 773px;
  padding-top: 136px;
  ._icon {
    width: 92px;
    height: 70px;
    display: inline-block;
  }
  .flexWrap {
    margin-top: 55px;
    .fl_box {
      width: 360px;
      height: 400px;
      background: #ffffff;
      border-radius: 14px;
      padding-top: 50px;
      transition: all 0.2s linear;
      &:hover {
        transform: translateY(-10px);
      }
      h3 {
        line-height: 28px;
        font-size: 28px;
        font-weight: 500;
        padding-top: 13px;
        padding-bottom: 14px;
      }
      p {
        line-height: 40px;
      }
    }
  }
}
</style>
